/**
 * Gauge Chart  component definition
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	Type,
	defineElementaryComponent,
	IScope,
	createSubScope,
	OBJECT_TYPE_PROP_NAME,
	OBJECT_TYPE
} from "@adapptio/lib-blueprint";

import { getStringEnumValue } from "@adapptio/lib-components";

import {
	getTimestamp,
	isNumber,
	isString,
	isValidValue,
	isUndefined,
	isDeepEqual,
	toNumber
} from "@adapptio/lib-shared";

import { termsEditor } from "../../terms";

import { ComponentGaugeChart_Events } from "./events";
import { ComponentGaugeChart_Props } from "./props";
import { ComponentGaugeChart_State } from "./state";

export const ComponentGaugeChart_Definition = defineElementaryComponent<
	typeof ComponentGaugeChart_Props,
	ComponentGaugeChart_State,
	typeof ComponentGaugeChart_Events
>({
	...termsEditor.components.gaugeChart.component,

	name: "caugeChart",

	category: "charts",

	icon: "mdi/gauge",

	docUrl: "...",

	order: 20,

	props: ComponentGaugeChart_Props,

	events: ComponentGaugeChart_Events,

	resolve: (spec, state) => {
		const {
			min,
			max,
			startAngle,
			endAngle,
			ranges = [],
			position,
			styleData,
			backgroundColor,
			foregroundColor,
			size,
			hand,
			ticks,
			label
			//grid
		} = spec;

		const {
			min: stateMin,
			max: stateMax,
			startAngle: stateStartAngle,
			endAngle: stateEndAngle,
			ranges: stateRanges,
			position: statePosition,
			styleData: stateStyleData,
			backgroundColor: stateBackgroundColor,
			foregroundColor: stateForegroundColor,
			size: stateSize,
			hand: stateHand,
			ticks: stateTicks,
			label: stateLabel
			//grid: stateGrid
		} = state || {};

		const settingsUpdated =
			min !== stateMin ||
			max !== stateMax ||
			startAngle !== stateStartAngle ||
			endAngle !== stateEndAngle ||
			!isDeepEqual(ranges, stateRanges) ||
			!isDeepEqual(position, statePosition) ||
			!isDeepEqual(styleData, stateStyleData) ||
			backgroundColor !== stateBackgroundColor ||
			foregroundColor !== stateForegroundColor ||
			size !== stateSize ||
			!isDeepEqual(hand, stateHand) ||
			!isDeepEqual(ticks, stateTicks) ||
			!isDeepEqual(label, stateLabel); /* ||
			grid !== stateGrid;*/

		return {
			min,
			max,
			startAngle,
			endAngle,
			ranges,
			position,
			styleData,
			backgroundColor,
			foregroundColor,
			size,
			hand,
			ticks,
			label,
			//grid,
			settingsTimestamp: !settingsUpdated ? state?.settingsTimestamp || 0 : getTimestamp()
		};
	},

	getScopeData: (spec, state) => {
		return {};
	},

	getScopeType: () => {
		return Type.Object({
			props: {}
		});
	}
});
